import styled, { css } from 'styled-components';
import FocusLock from 'react-focus-lock';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { breakpoints } from '../../foundation/breakpoints/values.js';
import { scrollbar } from '../../foundation/scrollbar/index.js';
import { List, ListItem } from '../../dataDisplay/List/styled.js';

function animateMenu(state) {
  if (!state) {
    return null;
  }
  switch (state) {
    case 'hidden':
      return css(["display:none;transform:translate(0,0.25rem);opacity:0;"]);
    case 'entering':
    case 'leaving':
      return css(["transform:translate(0,0.25rem);opacity:0;display:flex;"]);
    default:
      return css(["transform:translate(0,0);opacity:1;display:flex;"]);
  }
}
var MenuContainer = styled.div.withConfig({
  displayName: "MenuContainer",
  componentId: "sc-y0uo4i-0"
})(["z-index:1000;display:flex;flex-direction:column;position:relative;overflow:hidden;border-radius:", ";background-color:", ";box-shadow:", ";", ";transition:opacity ", " ", ",transform ", " ", ";", "{position:fixed;bottom:0;left:0;right:0;max-height:unset;}"], themeGet('borderRadius.md'), themeGet('colors.gray.0'), themeGet('dropShadow.200'), function (props) {
  return animateMenu(props.$state);
}, themeGet('motion.duration.fast'), themeGet('motion.easing.standard'), themeGet('motion.duration.fast'), themeGet('motion.easing.standard'), breakpoints.xs);
var MenuBodyContainer = styled.div.withConfig({
  displayName: "MenuBodyContainer",
  componentId: "sc-y0uo4i-1"
})(["display:flex;flex:1 1 auto;flex-direction:column;overflow:hidden auto;margin:", ";", ";"], themeGet('spacing.sm'), scrollbar());
var MenuList = styled(List).attrs({
  as: 'nav'
}).withConfig({
  displayName: "MenuList",
  componentId: "sc-y0uo4i-2"
})(["padding-left:", ";padding-right:", ";"], themeGet('spacing.sm'), themeGet('spacing.sm'));
var MenuItem = styled(ListItem).attrs(function (props) {
  return Object.assign({
    as: 'button',
    type: 'button'
  }, props);
}).withConfig({
  displayName: "MenuItem",
  componentId: "sc-y0uo4i-3"
})([""]);
var StyledFocusLock = styled(FocusLock).withConfig({
  displayName: "StyledFocusLock",
  componentId: "sc-y0uo4i-4"
})(["display:flex;flex-direction:column;overflow:hidden;"]);

export { MenuBodyContainer, MenuContainer, MenuItem, MenuList, StyledFocusLock };
